/* eslint-disable angular/document-service */
import { FirebaseFunctionsError } from '../../shared/customerrors.js';
import angular from "angular";

class DynamicBuilderCtrl {
  constructor(
    $scope,
    $window,
    $state,
    $timeout,
    $interval,
    $uibModal,
    TBService,
    ScriptLoaderService,
    SchemaService,
    FEService,
    FlashService,
    AuthService,
    TemplateService,
    TemplateValidationService,
    EventService,
    DomService,
    EDITOR_CONFIG
  ) {
    'ngInject';

    Object.assign(this, { $state, $window, $timeout, $interval, $scope, $uibModal, EDITOR_CONFIG });
    this.ss = SchemaService;
    this.tb = TBService;
    this.as = AuthService;
    this.fe = FEService;
    this.fs = FlashService;
    this.ts = TemplateService;
    this.tv = TemplateValidationService;
    this.es = EventService;
    this.sls = ScriptLoaderService;
    this.ds = DomService;
    this.tokenLoadCount = 0;
    this.loading = 'Loading Template...';

    this.sls.importExternalPageScripts('builder');

    this.td = {};
    this.duplicatingTemplate = false;
    this.discardOption = false;
    this.validationState = {};
    this.errorLevel = 0;
    this.removedBucket = [];
    this.fieldSenseTabIdx = -1;
    this.fieldSenseActive = true;
    this.fsFields = [];
    this.activeReportField = null;
    this._pageDims = null;
    const commonEditableBlocks = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    this.editableTags = ['div', 'table', 'span', ...commonEditableBlocks];
    this.reportOptions = {};
    this.prevReportOptions = {};
    this.editTagActions = [
      { tagNames: ['table'], name: 'fitWidth', title: 'Fit width', icon: 'fa-arrows-h', isModal: true, excludeClasses: [] },
      { tagNames: ['table', ...commonEditableBlocks], name: 'breakBefore', title: 'Insert paragraph before', icon: 'fa-arrow-up', isModal: true, excludeClasses: [] },
      { tagNames: ['div', 'table', ...commonEditableBlocks], name: 'breakAfter', title: 'Insert paragraph after', icon: 'fa-arrow-down', isModal: true, excludeClasses: [] },
      { tagNames: ['div', 'table', 'span', ...commonEditableBlocks], name: 'styles', title: 'Configure element', icon: 'fa-cog', isModal: false, excludeClasses: [] },
      { tagNames: ['div', 'span', ...commonEditableBlocks], name: 'trim', title: 'Replace with content', icon: 'fa-scissors', isModal: true, confirm: true, excludeClasses: ['fe-report-body', 'fe-report'] },
      { tagNames: ['div', 'table', 'span', ...commonEditableBlocks], name: 'remove', title: 'Remove element', icon: 'fa-trash', isModal: false, confirm: true, excludeClasses: [] },
    ];
    this.emptyReportContent = 'Double click to configure report';
    this.behaviorTags = ["div", "p", "table", "span"];
  }

  get pageDimensions() {
    return this._pageDims || this.tb.getDynamicPageDims(this.td.template.layout);
  }
  set pageDimensions(dims) {
    this._pageDims = dims;
  }

  get editor() {
    return CKEDITOR.instances.dynamicEditor;
  }

  async $onInit() {

    $('body').css('overflow-y', 'hidden');
    this.scrollbarWidth = this.tb.getScrollbarWidth();
    this.$fieldSenseList = $('field-sense-list');
    this.$fieldSenseList.hide();
    this.$dragDropSelector = $('.drag-drop-selector')[0];
    this.$dragSourceSelector = $('.drag-source-selector')[0];
    try {
      this.subscribePreEvents();

      [this.PROVIDER, this.td, this.realm] = await Promise.all([
        this.as.getProviderSettings(),
        this.ts.getTemplateData(),
        this.as.realm(),
        this.sls.waitForLibObject("CKEDITOR"),
      ]);

      if (!this.td) {
        this.fs.error("Cannot load template data! You may need to update your connection!");
        return;
      }
      if (this.td.template.realm !== this.realm) {
        this.fs.error(`You are logged in to ${this.realm}! Please login again to ${this.td.template.realm}.`);
        this.as.logout();
        return;
      }

      this.contentChanged = false;

      this.setConfirmLeave();

      this.dynamicContent = this.td.template.content || '';
      this.loading = '';

      this.$timeout(() => {
        this.bindComponentEvents();
        this.EDITOR_CONFIG.configEditor(CKEDITOR, this);
        this.validateMissingRequired();
        this.validateEmptyReferences();
        this.validateTableFields();
        this.validateChoiceFields();
        this.validateSelectOptions();
        this.validateTemplateSettings(true);
        this.updateBodyLayout();
        this.loadFonts();
        this.editor.on('key', e => this.editorKeyPress(e));
        this.setFieldSenseFields(this.selectedReferenceId);
        this.$scope.$watch('$ctrl.dynamicContent', (newVal, oldVal) => {
          if (!this.contentChanged && newVal != oldVal) {
            this.contentChanged = true;
          }
        });
      }, 500);

      // TODO: Don't trust the DOM (.click)
      if (this.$state.params.links === "true") angular.element('#links-btn').click();
      this.$scope.$apply(); //prevents occasional hanging on <loader>
    }
    catch (error) {
      const backendError = error instanceof FirebaseFunctionsError;
      !backendError && console.error(error);
      this.handleError(error, backendError);
    }
  }

  //#region Event handling
  $onDestroy() {
    this.ts.dispose();
    this.tv.dispose();
    this.es.disposeSubscribers("template");
    this.destroyEditor();
    this.$window.onbeforeunload = undefined;
    this.$state.$current.onExit = undefined;
  }

  handleError(error, fatal) {
    this.fs.error(`${error.message || error.toString()}`);
    fatal && this.$state.go('app.form-builder');
  }

  subscribePreEvents() {
    this.es.subscribeEvent(
      this.es.actions.AUTHENTICATE,
      async data => {
        if (data.updateConnection) {
          await this.updateConnection();
          return;
        }
        this.ignoreLeaveConfirm = true;
        this.as.logout(null, data.error);
      },
      'AUTHENTICATE_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.INTERNAL_ERROR,
      data => {
        this.loading = '';
        this.fs.error(data.error.message);
      },
      'INTERNAL_ERROR_DYNAMIC');
  }

  bindComponentEvents() {
    this.ts.subscribeUpdate(
      async (options) => {
        this.ts.updateTemplateData(this.td, options);
        options.extra?.replaceToken && this.insertTokens(options.extra.replaceToken);
        if (!options.keys?.length || options.keys.includes('appId')) {
          this.$timeout(() => {
            this.selectedReferenceId = null;
          });
        }
        if (!options.keys?.length || options.keys.includes('references')) {
          this.$timeout(_ => {
            this.validateMissingRequired();
            this.validateEmptyReferences();
            this.validateTemplateSettings(false);
          });
        }
      },
      'TEMPLATE_DATA_UPDATED_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.SAVE_TEMPLATE,
      (data) => { this.saveChanges(data); this.modal?.close() },
      'SAVE_TEMPLATE_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.FIELD_INSERT,
      (data) => { this.addNewToken(data) },
      'FIELD_INSERT_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.TEMPLATE_CONTENT_UPDATED,
      (data) => {
        this.templateContentUpdated(data);
      },
      'TEMPLATE_CONTENT_UPDATED_DYNAMIC');
    
    this.es.subscribeEvent(
      this.es.actions.TEMPLATE_SWAP_PLACEHOLDER_TOKENS,
      (data) => {
        this.swapTemplatePlaceholders(data);
      },
      'TEMPLATE_SWAP_PLACEHOLDER_TOKENS'
    );

    this.es.subscribeEvent(
      this.es.actions.TOKEN_SELECTED,
      (data) => { this.selectTokenCallback(data) },
      'TOKEN_SELECTED_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.REFERENCE_REMOVE_DONE,
      () => {
        this.$timeout(() => {
          this.refreshEditor();
        });
      },
      'REFERENCE_REMOVE_DONE_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.REFERENCE_SELECT_DONE,
      refId => {
        this.setReferenceTokensStyle(refId);
        this.setFieldSenseFields(refId)
      },
      'REFERENCE_SELECT_DONE_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.TEMPLATE_VALIDATED,
      (results) => {
        this.$timeout(() => {
          this.validationState = results.SUMMARY;
          if (!this.validationState.valid && (this.errorLevel != this.validationState.level.value)) {
            this.validationState.level.key && this.fs[this.validationState.level.key](this.validationState.level.warning);
          }
          this.errorLevel = this.validationState.level.value;
        });
      },
      'TEMPLATE_VALIDATED_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.TOKEN_REMOVE,
      (data) => {
        this.$timeout(_ => {
          this.deleteToken(data.token, data.closeModal);
        });
      },
      'TOKEN_REMOVE_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.MOUSE_ENTERED_BUILD_HEADER,
      _ => this.mouseEnteredBuildHeader(),
      'MOUSE_ENTERED_BUILD_HEADER_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.CONFIG_TARGET_TABLE,
      refId => {
        this.openTemplateOptions(refId, "#panelUploadField");
      },
      'CONFIG_TARGET_TABLE_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.CONFIG_TOKEN,
      data => this.openTokenModal(data.tokenId, null, "OPTIONS"),
      'CONFIG_TOKEN_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.REPORT_SELECTED, 
      (data) => { 
        this.$timeout(() => { 
          if (data.token) {
            this.fsFields = data.token.control.reportTableSchema?.fields || [];
            this.activeReportField = {tokenId: data.token.id};
          } else {
            this.setFieldSenseFields(this.selectedReferenceId);
            this.activeReportField = null;
          }
        });
      }, 'REPORT_SELECTED_DYNAMIC');

    this.es.subscribeEvent(
      this.es.actions.RESTORE_TEMPLATE,
      (data) => this.$timeout(() => this.restoreTemplateVersion(data)));
  }

  loadFonts() {
    this.fe.loadMissingFonts(true, false)
      .then((error) => { 
        if (error === true) 
          this.fs.error("Error loading fonts, please verify you're using valid Google fonts: https://fonts.google.com");
      });
  }
  
  editorKeyPress(ckEvent) {
    if (!this.fieldSenseActive || ckEvent.editor.mode === "source") return;
    
    const event = ckEvent.data.domEvent.$;
    const range = ckEvent.editor.getSelection().getRanges()[0];
    if (!range) return;
    const textEl = range.endContainer;
    const cursor = range.startOffset;
    const rootEl = range.root;
    const lastText = textEl.$.data?.slice(0, cursor) || '';
    // replace trailing no-break-space charcode 160 w/ regular space and
    // rm other garbage chars inserted by CKE, namely zero-width-chars
    const cleanedText = lastText.replace(/\xa0$/,' ').replace(/[^\x00-\x7F]/g, ''); 
    if (cleanedText.length < 3) return this.resetFieldSenseFilter();
    
    if (event.key.length === 1 && !event.metaKey && !event.ctrlKey) { // single letter has been pressed
      const actualText = cleanedText + event.key;
      this.applyFieldSenseList(actualText, false);
      return this.resetFieldSenseTabIdx();
    }
    
    switch (event.key) {
      case 'Backspace':
        this.applyFieldSenseList(cleanedText.slice(0, -1), true);
        return this.resetFieldSenseTabIdx();
      case 'Tab':
        event.preventDefault();
        return this.handleFieldSenseTabPress(event.shiftKey);
      case 'Enter':
        if (this.fieldSenseTabIdx === -1) return;
        ckEvent.cancel();
        return this.insertFieldSenseToken();
      case 'Shift': 
        return;
      case 'Escape':
        return this.resetFieldSenseFilter();
      default:
        this.resetFieldSenseFilter();
    }
  }
  //#endregion event handling

  //#region fieldSense utility methods
  applyFieldSenseList(text, isBackspace) {
    this.elementText = text;
    // a bookmark splits the text node at the cursor, placing a <span> there
    const bkmks = this.editor.getSelection().getRanges().createBookmarks();
    const $cursorBkmk = $(bkmks[0].startNode.$);
    $cursorBkmk.removeAttr('style'); // allow height calculation
    const textHeight = $cursorBkmk.height();
    
    // approximate left/right offset of impending keypress
    const appxCharWidth = textHeight / 2;
    const charOffset = (isBackspace ? -1 : 1) * appxCharWidth;

    // place FS box at cursor, relative to #dyn-builder-container
    const {top, left} = this.getRelativePosition($cursorBkmk, $('#dyn-builder-container'));
    $('field-sense-list').css('top', top + textHeight);
    $('field-sense-list').css('left', left + charOffset);

    this.$fieldSenseList.show();
    bkmks.forEach(b => b.startNode.$.remove());
  }

  getRelativePosition($element, $ancestor) {
    var offsetElement = $element.offset();
    var offsetAncestor = $ancestor.offset();
    var top = offsetElement.top - offsetAncestor.top;
    var left = offsetElement.left - offsetAncestor.left;
    return {top, left};
  }
  
  insertFieldSenseToken() {  // also used by field-sense-list component
    const $token = $('.field-sense-item.highlighted-field');
    if (!$token.length) return;
    
    const fieldId = $token.attr('field-id');
    const fText = $token.attr('filter-text');
    const pattern = new RegExp(`${fText}(?=[^${fText}]*$)`, 'i'); // last instance of match
    const reference = this.ts.refById(this.selectedReferenceId);
    const field = this.fsFields.find(f => f.id === fieldId);
    const $text = this.editor.getSelection().getRanges()[0].endContainer.$;
    // cursor jumps to end of active text-block after the following operation
    this.es.dispatchEvent(this.es.actions.FIELD_INSERT, { field, reference, reportField: this.activeReportField });
    $text.data = $text.data.replace(/\xa0$/,' ').replace(pattern, '');
    this.resetFieldSenseFilter();
  }
  
  handleFieldSenseTabPress(shiftKey) {
    this.fieldSenseTabIdx += shiftKey ? -1 : 1;
    const $fieldSenseListItems = $('.field-sense-item');
    
    if (this.fieldSenseTabIdx < 0) { // adjust out-of-range idx
      this.fieldSenseTabIdx = $fieldSenseListItems.length - 1;
    } else if (this.fieldSenseTabIdx === $fieldSenseListItems.length) {
      this.fieldSenseTabIdx = 0;
    }
    
    $fieldSenseListItems.removeClass('highlighted-field');
    return $($fieldSenseListItems[this.fieldSenseTabIdx]).addClass('highlighted-field');
  }
  
  resetFieldSenseFilter() {
    this.elementText = '';
    this.resetFieldSenseTabIdx();
    this.$fieldSenseList.hide();
  }
  
  resetFieldSenseTabIdx() {
    $('.field-sense-item.highlighted-field').removeClass('highlighted-field');
    this.fieldSenseTabIdx = -1;
  }
  
  toggleFieldSense(fsOn) {
    const newFsIcon = fsOn ? 'on' : 'off';
    const oldFsIcon = fsOn ? 'off' : 'on';
    $(`.cke_button__fieldsense${newFsIcon}`).show();
    $(`.cke_button__fieldsense${oldFsIcon}`).hide();
    this.resetFieldSenseFilter();
    this.fieldSenseActive = fsOn;
  }
  //#endregion fieldSense utility methods
  
  //#region Editor
  backgroundDoubleClick(event) {
    const classList = event.target.classList;
    if (classList.contains('cke_source')) return;
    classList.contains('cke_reset') && this.openTemplateOptions();
  }
  
  backgroundClick() {
    this.resetFieldSenseFilter();
  }

  isBlocksModeOn() {
    return $(".cke_button__showblocks.cke_button_on").length > 0;
  }

  setTableWidthsPxToIn() {
    $('.cke_wysiwyg_div').find('table[style*="width:"],td[style*="width:"]').each((i, el) => {
      let $el = $(el);
      let width = $el.prop("style")["width"];
      if (width && width.endsWith('px')) {
        const newWidth = ((parseFloat(width) * this.pageDimensions.innerWidthValue) / this.pageDimensions.widthPixels).toFixed(3);
        $el.css('width', newWidth + 'in');
      }
    });
  }

  setTagEvents() {

    $("#tagMenu").hide();
    $(".cke_wysiwyg_div").unbind('scroll').on('scroll', () => $("#tagMenu").hide());

    const selector = this.editableTags.join(',');
    this.activeTagMenu = false;

    $('.cke_wysiwyg_div')
      .find(selector).each((i, el) => {
        const $el = $(el);
        const tagName = $el.prop("tagName").toLowerCase();
        if (tagName == 'span' && $el.attr("class")) return; //cke widget
        if (tagName == 'div' && $el.prop("class").includes("cke_")) return; //cke-wrappers
        $el.unbind("mouseover").on('mouseover', (event) => {
          event.stopPropagation();
          this.activeTagMenu = false;
          if (!this.isBlocksModeOn()) return;
          this.activeTag = $el;
          this.activeTagName = `<${tagName}>`;
          this.activeTagActions = this.editTagActions
            .filter(a =>
              !a.excludeClasses.some(c => $el.hasClass(c)) &&
              a.tagNames.includes($el.prop('tagName').toLowerCase())
            );

          this.$timeout(_ => {
            $("#tagMenu").show();
            $("#tagMenu").css($el.offset());
          });
        });
      });
  }

  mouseEnteredBuildHeader() {
    this.hideTagMenu();
  }

  isSaveDisabled() {
    return (this.loading || this.isSourceMode() || !this.hasUnsavedChanges() || this.tokenLoadCount);
  }

  hideTagMenu() {
    this.activeTagMenu = false;
    $("#tagMenu").hide();
  }

  tagActionCancelled(action) {
    return action.confirm && !confirm(`Are you sure you want to ${action.name} the selected tag?`);
  }

  applyTagAction(action) {

    if (!this.activeTag || this.tagActionCancelled(action))
      return;

    switch (action.name) {
      case 'fitWidth':
        this.fitBlockWidth(this.activeTag);
        break;
      case 'styles':
        this.setHtmlBlockStyles(this.activeTag);
        break;
      case 'trim':
        this.removeBlock(this.activeTag, true);
        break;
      case 'remove':
        this.removeBlock(this.activeTag, false);
        break;
      case 'breakBefore':
        $('<p>&nbsp;</p>').insertBefore(this.activeTag);
        break;
      case 'breakAfter':
        $('<p>&nbsp;</p>').insertAfter(this.activeTag);
        break;
    }

    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
    this.setTagEvents();
  }

  updateTemplateObjectsFromContent(onChange, saving) {

    let invalidTokens = false;
    let removedTokens = false;
    let removedMessage = new Set();

    if (this.editor.mode == 'source') return;

    !onChange && this.removeReportLoaders();

    // Remove target table fields inside report bodies
    $('span.cke_widget_wrapper [data-token-id]').each((i, f) => {
      const $f = $(f);
      if (!$f.data("fieldId") && ($f.closest('.cke_widget_reportwidget').length > 0)) {
        invalidTokens = true;
        $f.parent().remove();
        removedMessage.add("All target table fields inside report bodies were removed!");
      }
    });

    const tokenElements = $(`.cke_widget_element[data-token-id]`);
    const contentTokens = Array.from(new Set(tokenElements.map(i => $(tokenElements[i]).data().tokenId)));

    // Remove tokens that are not in content
    this.ts.tokens.filter(t => !contentTokens.includes(t.id))
      .forEach(t => {
        removedTokens = true;
        this.removedBucket = this.removedBucket.filter(tb => tb.id !== t.id);
        this.removedBucket.push({ ...t });
        this.ts.removeToken(t.id, !saving);
      });
    saving && this.removedBucket.forEach(rt => !this.ts.tokens.some(t => t.id == rt.id) && this.ts.removeToken(rt.id));
    removedTokens && console.info("Tokens were removed!");

    // Remove behaviors with no blocks
    const blockIds = this.ts.getDynamicTemplateBlockIds();
    this.ts.behaviors
      .filter(b => b.childType == 'block' && !blockIds.includes(b.childId))
      .forEach(b => this.ts.removeBehavior(b.id));
    // Clear content without matching tokens
    contentTokens.filter(tId => !this.td.template.tokens.some(t => tId === t.id))
      .forEach(id => {
        const bkpToken = this.removedBucket.find(t => t.id == id);
        if (bkpToken) {
          this.td.template.tokens.push(bkpToken);
          return;
        }
        invalidTokens = true;
        $(`.cke_widget_wrapper [data-token-id="${id}"]`).parent().remove();
        removedMessage.add("All non-existent target table fields were removed!");
      });

    // Remove orphan report fields
    $('span.cke_widget_wrapper [data-field-id]').each((i, f) => {
      const $f = $(f);
      const tokenId = $f.data("tokenId");
      if (
        !tokenId ||
        !($f.closest('.fe-report-body').length > 0) ||
        !($f.closest(`.fe-report[data-token-id="${tokenId}"]`).length > 0)
      ) {
        invalidTokens = true;
        $f.parent().remove();
        removedMessage.add("All report fields outside of a report body were removed!");
      }
    });

    // Remove duplicate fields (users must create new intances to avoid behaviour issues, etc)
    contentTokens.forEach(id => { 
      const $duplicateFieldsById = $(`.cke_widget_wrapper [data-token-id="${id}"]:not(.fe-report *)`);
      if ($duplicateFieldsById.length <= 1) return;
      this.cloneDuplicateFields(id, $duplicateFieldsById);
      removedMessage.add("All duplicate fields were replaced by new fields. Only basic fuatures are copied (behaviors and other advanced features must be reacreated)!");
      invalidTokens = true;
    });

    if (invalidTokens) {
      this.dynamicContent = this.editor.getData();
      removedMessage.forEach(m => this.fs.warning(m));
    }

    this.validateMissingRequired();
    this.validateTableFields();
    this.validateChoiceFields();
    this.validateSelectOptions();
    this.validateEmptyReferences();
    this.$timeout(_ => this.deactivateReport());
  }

  getRenderedToken(data) {
    const behaviorDiv = this.ts.behaviors?.some(b => b.childId === data.id) ? `<i class="token-behaviors fa fa-cogs" title="Has behaviors" style="pointer-events: none;"></i>` : "";
    return `${behaviorDiv}${data.label}`;
  }

  destroyEditor() {
    CKEDITOR && this.editor?.destroy();
  }

  moveCursorAfterCurrentSelection() {
    const range = this.editor.getSelection()?.getRanges()[0];
    const endNode = range.endContainer;
    const endOffset = range.endOffset;
    range.setStart(endNode, endOffset);
    range.setEnd(endNode, endOffset);
    this.editor.getSelection().selectRanges([range]);
    this.editor.focus();
  }
  //#endregion Editor

  //#region add tokens
  async templateContentUpdated(data) {
    const { content, layout } = data;
    this.ts.template.layout = layout;
    this.ts.template.content = content;
    this.updateBodyLayout();
    this.dynamicContent = content;
    this.contentChanged = true;
    this.refreshEditor();
    this.$timeout(() => this.loadFonts(), 500);
  }

  async swapTemplatePlaceholders(data) {
    const { syncFields } = data;
    if (syncFields && syncFields.length > 0) {
      for (const field of syncFields) {
        await this.addNewToken(field);
      }
    }
    
    
  }

  /**
   * Select the first occurrence of `text` inside a CKEditor 4 instance.
   * Case-sensitive; tweak the `indexOf` line for case-insensitive search.
   *
   * @param {CKEDITOR.editor} editor
   * @param {string} text
   * @returns {boolean} true if found & selected, false otherwise
   */
  selectTextInEditor(editor, text) {
    if (!text) return false;

    const body = editor.editable();        // <body> of the editing iframe

    /* 1️⃣  Build a range that covers the whole editable area */
    const range = editor.createRange();     // same as new CKEDITOR.dom.range(editor.document)
    range.selectNodeContents(body);         // start = <body> start, end = <body> end

    /* 2️⃣  Create a walker that iterates over every text node in that range */
    const walker = new CKEDITOR.dom.walker(range);
    walker.evaluator = node => node.type === CKEDITOR.NODE_TEXT;

    /* 3️⃣  Search each text node for the query string */
    const query = String(text);
    for (let node; (node = walker.next());) {
      const pos = node.getText().indexOf(query);
      if (pos === -1) continue;

      const hit = editor.createRange();
      hit.setStart(node, pos);
      hit.setEnd(node, pos + query.length);

      editor.getSelection().selectRanges([hit]);
      editor.focus();
      return true;            // success
    }
    return false;             // nothing matched
  }


  async addNewToken(data) {

    /* ───────────────────────────────────────
     *  STEP 0: select placeholder text first
     * ─────────────────────────────────────── */
    if (data.placeholderText) {
      const found = this.selectTextInEditor(this.editor, data.placeholderText);
      if (!found) return;
    }

    // Report fields are not independent tokens:
    if (data.reportField) {
      if (!this.cursorInsideReport(true)) {
        this.fs.error("Report fields must be inside the report's body!");
        return;
      }
      const token = {
        ...this.getTokenById(data.reportField.tokenId),
        fieldSchema: { dropDimensions: data.field.dropDimensions, lineCount: data.field.lineCount }
      };
      this.editor.insertHtml(this.getTokenHtml(token, data.field));
      this.moveCursorAfterCurrentSelection();
      return;
    }

    // Set intial token data before control info is available
    let token = this.ts.initializeNewObject({
      'pageId': this.td.template.id, // Do this better?
      'templateId': this.td.template.id,
      'referenceId': data.reference.id,
      'fieldId': data.field.id.toString(),
      'layout': '',
      'control': {
        'type': "not-found",
        'getter': "noOp",
        'setter': "noOp"
      }
    });
    const srcToken = data?.srcToken;
    token.fieldSchema = this.ss.schemas[data.reference.tableId].fields.find(f => f.id == token.fieldId);
    token.id = srcToken?.id || token.id;
    token.options = srcToken?._options;
    if (this.PROVIDER.allowMultipleAttachments && data.field.id == 'form_engine_attachment') {
      token.fieldId += '_' + Date.now();
    }
    token._loading = true;
    this.tokenLoadCount++;

    const tokenHtml = this.getTokenHtml(token, null, srcToken);
    srcToken && this.ts.removeToken(srcToken.id);
    this.ts.tokens.push(token);

    this.updateTokenData();
    if (srcToken) {
      $(`span.cke_widget_wrapper>span.fe-token[data-token-id='${srcToken.id}'`).parent().replaceWith(tokenHtml);
      this.refreshEditor();
    }
    else this.editor.insertHtml(tokenHtml);

    this.moveCursorAfterCurrentSelection();

    try {
      const { data: { controls } } = await this.ts.fetchControls([token]);
      token.control = controls[0];
      delete token._loading;
    }
    catch (error) {
      this.deleteToken(token);
      this.handleError(error, false);
      return;
    }
    finally {
      this.tokenLoadCount--;
    }

    this.updateTokenData();

    $(`span.cke_widget_wrapper>span.fe-token[data-token-id='${token.id}'`).parent()
      .replaceWith(this.getTokenHtml(token, null, srcToken));
    const bkmrk = this.editor.getSelection().createBookmarks2();
    this.dynamicContent = this.getCleanContent();
    this.refreshEditor();

    this.validateMissingRequired();
    this.validateEmptyReferences();

    try { this.editor.getSelection().selectBookmarks(bkmrk) }
    catch { console.log('ckeditor range selection error') }

    this.$timeout(() => {
      if (!data.placeholderText && this.shouldOpenModal(token)) this.openTokenModal(token.id);
      this.setReferenceTokensStyle(token.referenceId);
    }, 100);
  }

  getTokenHtml(token, field, srcToken) {

    if (!field && this.tokenIsReport(token)) {
      const width = token.fieldSchema.dropDimensions.width;
      return `<div class="fe-report" data-token-id="${token.id}" style="width: ${width};">
        <span class="report-loader"><span class="fa fa-spin fa-spinner"></span>&nbsp;loading</span>
      </div><br/>`;
    }

    let css = '';
    const autoHeight = ['textarea-control'].includes(token.control.type);
    if (this.isResizableToken(token)) {
      css = this.tb.getInitialCss(null, token, 100, this.pageDimensions);
      if (autoHeight) css = { width: css.width, height: 'auto' };
      css = this.tb.getLayoutFromCssObj(css);
    }
    css += this.getNewTokenDefaultCss(token);
    if (srcToken?._css) css = this.tb.getLayoutFromCssObj({ ...this.tb.getCssObj(css), ...srcToken._css });

    const tokenHtml = field ?
      `<span class="fe-token" data-token-id="${token.id}" data-field-id="${field.id}" style="${css}"></span>` :
      `<span class="fe-token" data-token-id="${token.id}" style="${css}"></span>`;

    return tokenHtml;
  }

  getNewTokenDefaultCss(token) {
    let css = '';
    if (['checkbox-control', 'multicheckbox-control'].includes(token.control.type))
      css = 'outline: 0.16em solid black;';
    return css;
  }

  isResizableToken(token) {
    const resizableFormats = ['image', 'signature'];
    const resizableControls = ['checkbox-control', 'multicheckbox-control'];
    return resizableControls.includes(token.control.type) || resizableFormats.includes(token.format) || token.control.lineCount > 1;
  }

  insertTokens(replaceToken) {
    if (replaceToken) {
      this.closeModal();
      const tokens = replaceToken.newTokens.map(id => this.getTokenHtml(this.getTokenById(id))).join(' ');
      this.editor.insertHtml(tokens);
    }
  }

  cloneDuplicateFields(tokenId, $elements) {
    const origToken = this.getTokenById(tokenId);
    const regex = new RegExp(tokenId, "g");
    $elements.slice(1).parent().each((_, el) => {
      const clonedToken = angular.copy(origToken);
      const newTokenId = this.ts.getNewObjectId();
      clonedToken.id = newTokenId;
      this.ts.tokens.push(clonedToken);

      const $el = $(el);
      const html = $el.prop("outerHTML");
      const newHtml = html.replace(regex, newTokenId);
      // Child ckeditor widgets must be handled separately
      $el.find('.cke_widget_wrapper, .fe-action').each((_,chel) => {
        const $chel = $(chel);
        const html = $chel.prop("outerHTML");
        const newHtml = html.replace(regex, newTokenId);
        $chel.replaceWith(newHtml);
      });
      $(el).replaceWith(newHtml);
    });
    this.updateTokenData();
  }

  shouldOpenModal(token) {
    return token.fieldSchema.isFile || this.PROVIDER.reportControls.includes(token.control.type);
  }

  getWrapperAttributes(tokenId, fieldId) {

    let attributes = {};
    let classes = [];

    attributes['data-token-id'] = tokenId;

    const token = this.getTokenById(tokenId);
    if (!token) return { attributes, classes };

    const hasBehaviors = this.ts.behaviors?.some(b => b.childId === tokenId);
    token._hasBehavior = !!hasBehaviors;
    if (hasBehaviors) classes.push('fe-has-behavior');

    const format = token.format || token.fieldSchema?.fieldType;
    if (fieldId) attributes['data-field-id'] = fieldId;
    attributes.style = attributes.style || '';

    attributes.style += token.options?.choice ? "text-align: left;" : "text-align: center;";

    if (['image', 'checkbox'].includes(format) && !token._loading) {
      // svg background (for images and checkbox)
      attributes.style +=
        `background-image: url('./img/placeholder-${format}.svg'); background-size: contain; ` +
        `background-repeat: no-repeat; background-position-x: center; background-position-y: center;`;
    }
    attributes.title = this.getTokenTitle(tokenId, fieldId);

    if (this.selectedReferenceId == token.referenceId) {
      classes.push('fe-sel-reference');
    }

    return { attributes, classes };
  }

  getTokenLabel(tokenId, fieldId) {

    const token = this.getTokenById(tokenId);
    if (!token) return 'INVALID!';
    if (token._loading) return this.getLoaderLabel();

    // Report fields
    if (fieldId) return this.getReportFieldLabel(token, fieldId);

    // Radio/checkbox opts
    if (token.options?.choice) {
      if (token.control?.type === 'not-found') return this.getMissingLabel();
      return this.getOptionLabel(token);
    }

    // Checkbox
    if (token.fieldSchema?.fieldType === 'checkbox') return ' ';

    // Custom label
    if (typeof token.options?.label === 'string') return token.options.label || this.getBlankLabel();

    // Default label
    return this.getDefaultTokenLabel(token);
  }

  getReportFieldLabel(token, fieldId) {
    const fields = token?.control?.reportTableSchema?.fields;
    return fields?.find(f => f.id == fieldId)?.label || this.getMissingLabel();
  }

  getDefaultTokenLabel(token, includeHtml = true) {
    const field = token.fieldSchema;
    const found = !(token.control?.type === 'not-found');
    const cleanLabel = str => str.replace(/[\u00A0-\u9999<>\&]/gim, (i) => { return '&#' + i.charCodeAt(0) + ';' });
    return (field && found) ? cleanLabel(field.label) : this.getMissingLabel(includeHtml);
  }

  getMissingLabel(includeHtml = true) {
    return includeHtml ? "<span class='text-danger'>MISSING!</span>" : "MISSING!";
  }

  getOptionLabel(token) {
    const checkbox = token.control?.type == 'multicheckbox-control';
    const text = token.options.choice.display;
    const shape = checkbox ? 'square' : 'circle';
    const label = `<span class="cke_widget_option_label">${text}</span>`;
    const icon = checkbox ? '<span class="cke_widget_option_checkbox"></span>' : `<i class="fa fa-${shape}-o cke_widget_option_font"></i>`;
    return `${label}${icon}`;
  }

  getLoaderLabel() {
    return '<i class="fa fa-spin fa-spinner"></i>&nbsp;loading';
  }

  getBlankLabel() {
    return '[BLANK]';
  }

  getTokenTitle(tokenId, fieldId) {
    const token = this.getTokenById(tokenId);
    if (!token) return 'INVALID!';
    if (token._loading) return 'Loading...';

    const reportFieldLabel = fieldId ? this.getReportFieldLabel(token, fieldId) : null;
    const refName = this.ts.references.find(r => r.id == token.referenceId)?.name;
    const defaultLabel = this.getDefaultTokenLabel(token, false);

    const title = `${refName}\n${defaultLabel}` +
      (reportFieldLabel ? `\n${reportFieldLabel}` : '') +
      (token.options?.choice ? `\nChoice: ${token.options?.choice.value}` : '');
    return title;
  }
  //#endregion add token

  //#region Token selection

  setHtmlBlockStyles(element) {

    this.removeResizable();

    this.modalPageStyles = false;
    this.selectedBlock = $(element);

    if (this.selectedBlock[0].hasAttribute('data-cke-temp')) {
      this.setBlockStyles();
      return;
    }

    if (this.selectedBlock.hasClass('cke_widget_wrapper') || this.selectedBlock.hasClass('fe-report')) {
      this.openTokenModal(this.selectedBlock[0].attributes['data-token-id'].value, this.selectedBlock[0].attributes['data-field-id']?.value);
      return;
    }

    this.selectedTagNames = `<${this.selectedBlock[0].tagName}>`;
    this.styleModalTitle = `Set ${this.selectedTagNames} styles`;
    this.blockStyles = this.selectedBlock.attr('style') || '';

    this.openBlockModal();
  }

  splitBlock() {

    if (this.$window.getSelection().toString() != '') {
      this.fs.error('First deselect any content and place the cursor where you want to insert the blocks!');
      return;
    }

    this.splitBlockRange = (n) => new Array(parseInt(n));
    this.blockCount = 2;
    this.modal?.close();
    this.blockOrientation = 'horizontal';
    this.blockCountOptions = Array.from({ length: 9 }, (_, i) => i + 2);

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      windowClass: 'split-block-modal',
      template: `
      <div class="modal-header">
        <h3 class="modal-title">Insert Blocks</h3>
      </div>
      <div class="modal-body" ng-init="$ctrl.blockCount=$ctrl.blockCount||2">
        <div class="row" style="margin: 10px; text-align: center;">
          <button type="button" class="btn btn-default" ng-class="{'btn-primary': $ctrl.blockOrientation==='horizontal'}" ng-click="$ctrl.blockOrientation='horizontal'">Horizontal</button>
          <button type="button" class="btn btn-default" ng-class="{'btn-primary': $ctrl.blockOrientation==='vertical'}" ng-click="$ctrl.blockOrientation='vertical'">Vertical</button>
        </div>
         <div class="row" style="margin: 10px; text-align: center;">
           <select class="form-control" style="width:80px; display:inline-block;" ng-model="$ctrl.blockCount" ng-options="n for n in $ctrl.blockCountOptions"></select>
         </div>
        <div class="row" style="margin-top:6px;">
          <div style="display:flex; margin:10px;">
            <div style="display:flex; width:100%; border:1px dashed #c3c3c3; padding:4px;"
              ng-style="{'flex-direction': ($ctrl.blockOrientation==='vertical' ? 'column' : 'row')}">
              <div ng-repeat="a in $ctrl.splitBlockRange($ctrl.blockCount) track by $index"
                style="display:flex; align-items:center; justify-content:center; flex:1; min-width:32px; min-height:32px; border:1px solid #ddd; margin:2px;">
                {{$index + 1}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="btn-group btn-group-justified" role="group" aria-label="...">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-primary" ng-click="$ctrl.applyBlockSplit($ctrl.blockCount)">Add</button>
          </div>
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-warning" 
              ng-click="$ctrl.closeModal()">Cancel</button>
          </div>
        </div>
      </div>`,
      scope: this.$scope,
      size: 'lg'
    });

  }

  applyBlockSplit(count) {
    const isMulti = count > 1;
    const flexDirection = this.blockOrientation === 'vertical' ? 'column' : 'row';
    const blockHtml = isMulti ?
      `<div style="display:flex; flex-direction: ${flexDirection}">
        ${Array.from(Array(count).keys()).map(_=>`<div style="flex:1"><p></p></div>`).join('')}
      </div>` :
        `<div><p>&nbsp;</p></div>`;
    this.editor.insertHtml(blockHtml);
    this.closeModal();
  }

  setBlockStyles(isPageBlock) {

    this.removeResizable();

    if (!isPageBlock) {
      this.selectedBlock = $('.cke_table-faked-selection');
      if (this.selectedBlock.length == 0) {
        const sel = this.$window.getSelection();
        let bNode = sel.anchorNode;
        let eNode = sel.focusNode;
        let baseDepth = 0, extentDepth = 0, firstNode, lastNode;

        if (bNode != eNode) {
          // get node depths
          while (!$(bNode.parentElement).hasClass('cke_editable')) { baseDepth++; bNode = bNode.parentElement }
          while (!$(eNode.parentElement).hasClass('cke_editable')) { extentDepth++; eNode = eNode.parentElement }
          if (baseDepth <= extentDepth) { firstNode = sel.anchorNode; lastNode = sel.focusNode }
          else { firstNode = sel.focusNode; lastNode = sel.anchorNode }
          // move lower to same level
          for (let t = 0; t < Math.abs(baseDepth - extentDepth); t++) {
            lastNode = lastNode.parentElement;
          }
          // move until common parent
          while (lastNode.parentNode != firstNode.parentNode) {
            firstNode = firstNode.parentElement;
            lastNode = lastNode.parentNode;
          }
          // get siblings selection range
          const parent = firstNode.parentNode;
          const siblings = $(parent).children();
          let selInit = null, selEnd = null;
          for (let i = 0; i < siblings.length; i++) {
            const eNode = $(siblings[i]).get(0);
            if (selInit === null && (eNode == firstNode || eNode == lastNode)) selInit = i;
            else if (selInit !== null && selEnd == null && (eNode == firstNode || eNode == lastNode)) {
              selEnd = i;
              break;
            }
          }
          // select elements
          if (selInit === null) this.selectedBlock = $(bNode).parent();
          if (selEnd === null) {
            if (firstNode == lastNode) this.selectedBlock = $(firstNode);
            else this.selectedBlock = this.selectedBlock = $(firstNode).parent();
          }
          else this.selectedBlock = siblings.filter(i => i >= selInit && i <= selEnd);

          const tagNames = Array.from(new Set(this.selectedBlock.toArray().map(e => e.tagName)));
          this.selectedTagNames = '(' + tagNames.map(t => `${t.toLowerCase()}`).join(', ') + ')';
        }
        else {
          this.selectedBlock = $(bNode).parent();
          this.selectedTagNames = `<${this.selectedBlock[0].tagName}>`;
        }
      }
      else this.selectedTagNames = `<${this.selectedBlock[0].tagName}>`;
      this.modalPageStyles = this.selectedBlock.hasClass('cke_wysiwyg_div');

    }
    else {
      this.selectedBlock = $('cke_wysiwyg_div');
      this.modalPageStyles = true;
    }

    this.styleModalTitle = this.modalPageStyles ?
      'Set Page styles' :
      `Set ${this.selectedTagNames} ${(this.selectedBlock.length > 1) ? 'group' : ''} styles`;
    this.blockStyles = this.modalPageStyles ? this.td.template.layout : this.tb.getJqElementsSharedStyles(this.selectedBlock);

    this.styleRegex = this.modalPageStyles ?
      [{ styles: ['width', 'height', 'margin-left', 'margin-right', 'margin-top', 'margin-bottom'], regex: /[0-9|.]+in/, message: "Page dimensions must be in inches!" }] :
      [];

    this.openBlockModal();
  }

  openBlockModal() {
    this.invalidCss = false;
    this.removedProps = [];
    this.tagAction = null;
    this.tagActions = (this.selectedBlock.length === 1) ?
      this.editTagActions.filter(a => a.isModal && a.tagNames.includes(this.selectedBlock[0].tagName.toLowerCase())) : [];
    this.allowBlockBehaviors = (this.selectedBlock.length === 1) && this.behaviorTags.includes(this.selectedBlock[0].tagName.toLowerCase());
    this.selectedBlockId = this.allowBlockBehaviors ? (this.selectedBlock[0].dataset.blockId || this.ts.getNewObjectId()) : null;
    this.hasBehaviors = this.allowBlockBehaviors && this.selectedBlockId && this.td.template.behaviors.some(b => b.childId === this.selectedBlockId);

    this.modal?.close();

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      windowClass: 'block-styles-modal',
      template: `
      <div class="modal-header">
        <h3 class="modal-title">{{$ctrl.styleModalTitle}}</h3>
      </div>
      <div class="modal-body">
      <!-- Display section -->
        <div class="panel panel-default">
          <div class="panel-heading" ng-click="showDisplay=!showDisplay" ng-init="showDisplay=true">
            <h3 class="panel-title">
              Display
              <span ng-class="{'dropup': showDisplay}">
                <span class="caret"></span>
              </span>
            </h3>
          </div>
          <div class="panel-body" ng-if="showDisplay">
            <div class="form-group-sm">
              <css-builder css="$ctrl.blockStyles" title="'Element Styles'" invalid-css="$ctrl.invalidCss" removed-props="$ctrl.removedProps"
                validate="true" page-styles="$ctrl.modalPageStyles" style-regex="$ctrl.styleRegex"></css-builder>
            </div>
          </div>
        </div>
        <!-- Behaviors section -->
        <div class="panel panel-default" ng-if="$ctrl.allowBlockBehaviors">
          <div class="panel-heading" ng-click="showBehavior=!showBehavior" ng-init="showBehavior=$ctrl.hasBehaviors">
            <h3 class="panel-title">
              Behaviors
              <span ng-class="{'dropup': showBehavior}">
                <span class="caret"></span>
              </span>
            </h3>
          </div>
          <div class="panel-body" ng-if="showBehavior">
            <div class="form-group-sm">
              <field-behaviors block-id="$ctrl.selectedBlockId"></field-behaviors>
            </div>
          </div>
        </div>
        <div ng-if="$ctrl.tagActions.length" class="row tag-actions">
          <div class="col-sm-3">
            <select 
              class="form-control"
              ng-options="act as act.title for act in $ctrl.tagActions" 
              ng-model="$ctrl.tagAction" ng-change="$ctrl.blockActionsModal($ctrl.tagAction)">
              <option value="">--Select an action--</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="btn-group btn-group-justified" role="group" aria-label="...">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" ng-disabled="$ctrl.invalidCss"
              ng-click="$ctrl.applyBlockStyles()">Apply</button>
          </div>
          <div class="btn-group" role="group" ng-if="!$ctrl.modalPageStyles">
            <button type="button" class="btn btn-danger"
              ng-click="$ctrl.blockRemoveModal()">Remove</button>
          </div>
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-warning" 
              ng-click="$ctrl.closeModal()">Cancel</button>
          </div>
        </div>
      </div>`,
      scope: this.$scope,
      size: 'lg'
    });
  }

  blockActionsModal(action) {
    this.tagAction = null;
    if (this.tagActionCancelled(action)) return;

    switch (action.name) {
      case 'fitWidth':
        this.fitBlockWidth(this.selectedBlock);
        break;
      case 'trim':
        this.removeBlock(this.selectedBlock, true);
        break;
      case 'breakBefore':
        $('<p>&nbsp;</p>').insertBefore(this.selectedBlock);
        break;
      case 'breakAfter':
        $('<p>&nbsp;</p>').insertAfter(this.selectedBlock);
        break;
    }
    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
    this.closeModal();
  }

  fitBlockWidth(block) {
    block.removeAttr('width')
      .css({
        width: '100%',
        'margin-left': '', 'margin-right': '',
        'padding-left': '', 'padding-right': ''
      });
    block.find('span,td,tr,th,p,div')
      .removeAttr('width')
      .css({
        'width': '',
        'margin-left': '', 'margin-right': '',
        'padding-left': '', 'padding-right': ''
      });
    this.dynamicContent = this.editor.getData();
  }

  removeBlock(block, trim) {
    if (block.hasClass('fe-report-body') || block.hasClass('fe-report') || block.children('tbody').children('tr.fe-report-body').length) {
      if (trim) return;
      block = block.closest('.cke_widget_wrapper');
      if (block.length == 0) return;
    }
    trim ? block.replaceWith(block.html().trim()) : block.remove();
    !trim && this.deselectContent();
    this.setTagEvents();
  }

  blockRemoveModal(trim) {
    this.removeBlock(this.selectedBlock, trim);
    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
    this.closeModal();
  }

  applyBlockStyles() {
    this.selectedBlock.css(this.tb.getCssObj(this.blockStyles));
    this.removedProps.forEach(key => this.selectedBlock.css(key, ''));
    if (this.selectedBlockId) this.selectedBlock.attr('data-block-id', this.selectedBlockId);
    this.modalPageStyles && this.updateTemplateLayout();
    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
    this.closeModal();
  }

  updateTemplateLayout() {

    this._pageDims = null;
    const tempPageDims = this.tb.getDynamicPageDims(this.blockStyles);
    if (tempPageDims.innerWidthValue < 0.1 || tempPageDims.innerHeightValue < 0.1) {
      this.fs.error('Invalid margins, layout could not be updated!');
      return;
    }

    this.td.template.layout = this.blockStyles;
    this.$timeout(() => this.updateBodyLayout());
  }

  updateBodyLayout(resetSize) {
    const pageLoaded = this.$interval(
      () => {
        if ($('div.cke_wysiwyg_div').length) {

          this.$interval.cancel(pageLoaded);

          const pageStyles = this.tb.getCssObj(this.td.template.layout);
          pageStyles.width = this.pageDimensions.innerWidth;
          const style = this.tb.getLayoutFromCssObj(pageStyles);
          $('div.cke_wysiwyg_div').attr('style', style);
          $('div.cke_wysiwyg_div').css({
            'height': 'auto', 'margin': '0px', 'padding': '0px', 'overflow': 'hidden'
          });

          this.setPathToolbarEvents();
          this.setEditorContentWidth();

          if (resetSize) this._pageDims = null;
        }
      }, 200);
  }

  setEditorContentWidth() {
    const containerWidth = this.pageDimensions.widthPixels + this.scrollbarWidth;
    $('div.cke_contents').css('width', `${containerWidth}px`);
    $('div.cke_contents').off('scroll').on('scroll', (evt) => {
      this.hideTagMenu();
    });
    $('div.cke_contents').off('click').on('click', (evt) => {
      this.editor.focus();
    });
  }

  setPathToolbarEvents() {
    $('.cke_bottom').off('mouseenter').on('mouseenter', () => this.editor.bottomActive = true);
    $('.cke_bottom').off('mouseleave').on('mouseleave', () => this.editor.bottomActive = false);
  }

  getTokenById(tokenId) {
    return this.td.template.tokens.find(t => t.id == tokenId);
  }

  selectTokenCallback(token) {
    this.selectTokenReference(token);
    this.scrollToToken(token);
  }

  scrollToToken(token) {
    const element = $(`.cke_widget_wrapper[data-token-id='${token.id}']`);
    element.length && element[0].scrollIntoView();
  }

  selectTokenReference(token) {
    this.es.dispatchEvent(
      this.es.actions.REFERENCE_SELECT_BEGIN,
      { referenceId: token.referenceId });
  }

  setReferenceTokensStyle(refId) {
    refId = refId || this.selectedReferenceId;
    $(".fe-sel-reference").removeClass('fe-sel-reference');
    this.td.template.tokens.filter(t => t.referenceId === refId).forEach(t => {
      $(`.cke_widget_element[data-token-id='${t.id}']`).parent().addClass('fe-sel-reference');
    });
  }
  
  setFieldSenseFields(refId) {
    this.fsFields = this.ts.refById(refId)?.tableSchema.fields || [];
  }

  cleanupTemplateContent() {
    this.removeContentTempStyles();
    this.removeInvalidAttributes();
  }

  validateTemplateContent() {
    const validReports = this.validateReportsContent();
    return validReports;
  }

  validateReportsContent() {
    let valid = true;

    this.ds.getAddReportTokenIds().forEach(tokenId => {
      const token = this.getTokenById(tokenId);
      if (!token) return;
      const reportFieldIds = this.ds.getReportFieldIds(tokenId);
      const reqFields = this.ss.getTableSchemaRequiredFields(token.control?.reportTableSchema);
      if (!reqFields.length) return;

      const missingReqFields = reqFields.reduce((acc, fieldId) => {
        if (!reportFieldIds.has(fieldId)) return acc.add(fieldId);
        return acc;
      }, new Set());
      if (!missingReqFields.size) return;

      const reportName = token.fieldSchema?.label || `Report ${tokenId}`;
      this.fs.error(`Missing required fields (${Array.from(missingReqFields).join(", ")}) on report with "add" button: "${reportName}"!`);
      valid = false;
    });
    return valid;
  }

  removeContentTempStyles() {
    /*const tempClasses = ['fe-sel-reference'];
    tempClasses.forEach(c => { 
      $(`.${c}`).removeClass(c);
    });*/
    // Remove resizable widget classes
    const resizeW = $(`div[class^='ui-resizable']`);
    if (resizeW.length) {
      resizeW.remove();
      this.dynamicContent = this.editor.getData();
    }
    // Remove garbage occasionaly injected by ckeditor
    const tempCKEditor = $('span[id^="cke_bm_"]');
    if (tempCKEditor.length) {
      tempCKEditor.remove();
      this.dynamicContent = this.editor.getData();
    }
  }

  removeInvalidAttributes() {
    this.dynamicContent = this.dynamicContent.replace(/\s+contenteditable(?:="[^"]*")?\s*/gi, '');
  }

  removeReportLoaders() {
    const $loaders = $('span.report-loader');
    if ($loaders.length) {
      console.log('replacing..');
      $loaders.replaceWith(this.emptyReportContent);
      this.dynamicContent = this.editor.getData();
    }
  }

  removeResizable() {
    try { $('.ui-resizable').resizable('destroy') } catch (e) { null }
  }

  deselectContent() {
    this.editor.getSelection().removeAllRanges();
  }

  makeTokenResizable(tokenId, fieldId) {
    this.removeResizable();

    const token = this.getTokenById(tokenId);
    if (!token?.fieldSchema || !this.isResizableToken(token)) return;

    const selector = fieldId ?
      `.cke_widget_wrapper[data-token-id='${tokenId}'][data-field-id='${fieldId}']` :
      `.cke_widget_wrapper[data-token-id='${tokenId}']`;

    $(selector).resizable({
      handles: "e, s",
      stop: (e, ui) => {

        const direction = (ui.size.width - ui.originalSize.width) ? 'width' : 'height';
        const $element = $(ui.element).closest('.cke_widget_wrapper');
        const borderWidth = parseFloat($element.css('border-width')) * 2;
        const origVal = parseFloat($element.prop("style")[direction]) - borderWidth;
        const adjust = this.pageDimensions.innerWidthValue / this.pageDimensions.widthPixels;

        const $token = fieldId ?
          $(`span.fe-token[data-token-id='${tokenId}'][data-field-id='${fieldId}'][data-widget='tokenwidget']`) :
          $(`span.fe-token[data-token-id='${tokenId}'][data-widget='tokenwidget']`);
        const newVal = (origVal * adjust).toFixed(3);
        const newStyles = { [direction]: `${newVal}in` };

        if (direction == 'height') {
          const token = this.getTokenById(tokenId);
          const fontStyles = this.tb.getFontSizeCss(newStyles['height'], token.control.lineCount, token, false);
          if (fontStyles) {
            newStyles['line-height'] = fontStyles['line-height'];
            newStyles['font-size'] = fontStyles['font-size'];
          }
        }
        else {
          //newStyles.width = Math.min(newVal, this.pageDimensions.innerWidthValue) + 'in';
        }

        $token.css(newStyles);

        this.contentChanged = true;

        const wrapper = fieldId ?
          $(`span.cke_widget_wrapper[data-token-id='${tokenId}'][data-field-id='${fieldId}']`) :
          $(`span.cke_widget_wrapper[data-token-id='${tokenId}']`);
        wrapper.css({ width: 'auto', height: 'auto' });
      }
    });
  }

  updateTokenData() {
    this.ts.notifyUpdate(["tokens"], this.td);
    this.validateSelectOptions();
  }

  openTokenModal(tokenId, fieldId, section = '') {

    if (this.loading) return;
    this.removeResizable();

    const token = this.getTokenById(tokenId);

    if (token._loading) return;
    if (!token?.fieldSchema || token?.control?.type === 'not-found') {
      this.fs.error('Field is missing!');
      return;
    }

    if (fieldId) {
      this.openFieldModal(token, fieldId);
      return;
    }
    console.info(tokenId);

    this.tokenIsReport(token) && this.getTokenReportSettings(token);
    this.selectTokenReference(token);
    this.activeToken = token;
    this.originalActiveToken = angular.copy(token);
    const elements = $(`.cke_widget_element[data-token-id='${token.id}']`);
    this.tokenStyle = elements[0].attributes['style']?.value || '';
    this.invalidCss = false;
    this.activeSection = section;

    this.modal?.close();

    this.saveEditorScrollPosition();

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      windowClass: 'token-modal',
      template: `<token-form
                  token="$ctrl.activeToken"
                  style="$ctrl.tokenStyle"
                  report-options="$ctrl.reportOptions"
                  invalid-css="$ctrl.invalidCss"
                  section="$ctrl.activeSection"
                  on-update="$ctrl.tokenUpdateModal(token)"
                  on-cancel="$ctrl.cancelModal()">
                </token-form>`,
      scope: this.$scope,
      size: 'lg'
    });
    this.modal.result.then(
      closed => this.tokenClosedModal(),
      canceled => this.tokenCancelModal()
    );
  }

  openFieldModal(token, fieldId) {
    console.info(`${token.id} : ${fieldId}`);
    this.removeResizable();

    const elements = $(`.cke_widget_element[data-token-id='${token.id}'][data-field-id='${fieldId}']`);
    if (!elements.length) {
      this.fs.error('Field not found!');
      return;
    }
    this.tokenStyle = elements[0].attributes['style']?.value || '';
    this.activeField = { tokenId: token.id, fieldId };
    // User must use ckeditor tools to set these styles or token html can break:
    this.invalidProps = ["font-style", "font-weight"];
    this.invalidCss = false;

    this.modal?.close();

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
      <div class="modal-header">
        <h3 class="modal-title">Set Report Field styles</h3>
      </div>
      <div class="modal-body">
        <!-- Display section -->
        <div class="panel panel-default">
          <div class="panel-heading" ng-click="showDisplay=!showDisplay" ng-init="showDisplay=true">
            <h3 class="panel-title">
              Display
              <span ng-class="{'dropup': showDisplay}">
                <span class="caret"></span>
              </span>
            </h3>
          </div>
          <div class="panel-body" ng-if="showDisplay">
            <div class="form-group-sm">
              <css-builder css="$ctrl.tokenStyle" title="'Styles'" validate ="true"  invalid-css="$ctrl.invalidCss"
                invalid-props="$ctrl.invalidProps"></css-builder>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="btn-group btn-group-justified" role="group" aria-label="...">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" ng-disabled="$ctrl.invalidCss"
              ng-click="$ctrl.fieldUpdateModal()">Apply</button>
          </div>
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-warning" 
              ng-click="$ctrl.closeModal()">Cancel</button>
          </div>
        </div>
      </div>`,
      scope: this.$scope,
      size: 'lg'
    });
  }

  fieldUpdateModal() {
    this.closeModal();

    const elements = $(`span.fe-token[data-token-id='${this.activeField.tokenId}'][data-field-id='${this.activeField.fieldId}'][data-widget='tokenwidget']`);
    elements.attr('style', this.tokenStyle);

    this.dynamicContent = this.getCleanContent();
    this.refreshEditor();
    this.$timeout(() => { this.loadFonts() }, 400);
  }

  async tokenUpdateModal(token) {
    const fieldChanged = (token.referenceId != this.originalActiveToken.referenceId || token.fieldSchema.id != this.originalActiveToken.fieldSchema.id);
    if (fieldChanged && !confirm("Changing the associated table field will reset some properties of your field. Do you want to continue?")) {
      this.tokenCancelModal();
      this.closeModal();
      return;
    }

    this.updateTokenData();
    this.closeModal();

    if (this.tokenIsReport(token)) {
      this.activateTokenReport(token.id);
      if (this.reportOptions.type !== this.prevReportOptions?.type || this.reportOptions.fields?.length) {
        this.setReportContent(token);
      }
      this.updateReportSettings(token);
    }

    this.$timeout(_ => {
      const elements = this.tokenIsReport(token) ?
        $(`div.fe-report[data-token-id='${token.id}'][data-widget='reportwidget']`) :
        $(`span.fe-token[data-token-id='${token.id}'][data-widget='tokenwidget']`);
      elements.attr('style', this.tokenStyle);
      this.dynamicContent = this.getCleanContent();
      this.refreshEditor();
      this.$timeout(_ => {
        fieldChanged && this.changeTokenFieldId(token);
        this.loadFonts();
      }, 400);
    });
  }

  async restoreTemplateVersion(data) {
    this.modal?.close();

    if (!data.clone) {
      this.restoreTemplateVersionModal(data.versionRecord);
      return;
    }
    if (!confirm(`Are you sure you want to create a new template using version ${data.versionRecord.versionNumber}?`)) return;
    await this.saveChangesAs(data.versionRecord.versionNumber);
  }

  restoreTemplateVersionModal(versionRecord) {

    if (this.hasUnsavedChanges()) {
      this.fs.error('Please save or discard your changes before restoring a version!');
      return;
    }

    this.versionRecord = versionRecord;
    this.modal = this.$uibModal.open({
      backdrop: 'static',
      windowClass: 'restore-template-modal',
      template: `<restore-template
                  version-record="$ctrl.versionRecord"
                  template="$ctrl.td.template"
                  on-update="$ctrl.reloadWindow()"
                  on-cancel="$ctrl.cancelModal()">
                </token-form>`,
      scope: this.$scope,
      size: 'lg'
    });
    this.modal.result.then(
      closed => this.closeModal(),
      canceled => this.closeModal()
    );
  }

  changeTokenFieldId(token) {

    const tableId = this.ts.refById(token.referenceId).tableId;
    const data = {
      field: { id: token.fieldSchema.id },
      reference: { id: token.referenceId, tableId },
      srcToken: token
    };

    const elements = $(`.cke_widget_element[data-token-id='${token.id}']`);
    const tokenStyle = elements[0].attributes['style']?.value || '';
    token._css = this.tb.getCssObj(tokenStyle);
    ["height", "width", "font-size", "line-height"].forEach(prop => delete token._css[prop]);

    token._options = token?.options?.label ? { label: token.options.label } : undefined;

    this.addNewToken(data);
  }

  getCleanContent() {
    const regex = /[\s|\t]*<div class="ui-resizable[a-z|\-|\s]*" style="[a-z|:|\-|\s|;|0-9]*">&nbsp;<\/div>/g;
    const content = this.editor.getData().replace(regex, '');
    return content;
  }

  deleteToken(token, closeModal) {
    if (this.tokenIsReport(token)) {
      $(`div.fe-report[data-token-id='${token.id}']`)?.parent().remove();
    }
    else {
      $(`span.cke_widget_wrapper>span.fe-token[data-token-id='${token.id}'`)?.parent().remove();
    }
    this.dynamicContent = this.editor.getData();
    closeModal && this.closeModal();
    this.updateTemplateObjectsFromContent();
  }

  cancelModal() {
    this.modal.dismiss("Canceled");
    this.closeModal();
    this.restoreEditorScrollPosition();
  }

  tokenClosedModal() { }

  tokenCancelModal() {
    let tokenIndex = this.td.template.tokens.findIndex(t => t.id == this.activeToken.id);

    this.td.template.tokens[tokenIndex] = {
      ...angular.copy(this.originalActiveToken)
    };

    this.activeToken = this.originalActiveToken = undefined;
  }

  openLoginModal(realm) {
    const { prefix, domain } = this.PROVIDER;
    return new Promise((resolve, reject) => {
      const loginModal = this.$uibModal.open({
        template: `<${prefix}-login options="$ctrl.loginOptions"></${prefix}-login>`,
        scope: this.$scope,
        backdrop: 'static',
        keyboard: false,
        size: 'md'
      });

      this.loginOptions = {
        realm,
        title: `Login to ${realm}.${domain}`,
        onSuccess: (user) => {
          loginModal.dismiss("Canceled");
        }
      };

      loginModal.result.then(
        closed => { resolve() },
        canceled => { resolve() }
      );

    });
  }

  async openTemplateOptions(refId, highlightSection) {
    this.targetTableId = refId;
    this.highlightSection = highlightSection;
    const optionsTemplate =
      `<template-options
        template="$ctrl.td.template"
        dynamic="true"
        reference-id=$ctrl.targetTableId
        ignore-leave-confirm=$ctrl.ignoreLeaveConfirm
        highlight-sec=$ctrl.highlightSection
        on-cancel="$ctrl.cancelModal()">
      </template-options>`;

    this.removeResizable();

    this.modal?.close();

    this.modal = this.$uibModal.open({
      template: optionsTemplate,
      scope: this.$scope,
      size: "xlg"
    });

    this.modal.result.then(
      closed => null,
      canceled => null
    );
  }
  //#endregion Token selection

  //#region Reports

  activateTokenReport(tokenId, deactivate) {
    const token = tokenId ? this.getTokenById(tokenId) : null;
    token && this.selectTokenReference(token);
    this.activeReportToken = token;
    this.$timeout(() => {
      this.es.dispatchEvent(
        this.es.actions.REPORT_SELECTED,
        { token, deactivate });
    }, 100);
  }

  updateReportSettings(token) {
    const opts = token.options;
    const removeBtns = [];
    !opts.downloadReport && removeBtns.push("download");
    !opts.insertRecords && removeBtns.push("insert");
    !(opts.insertRecords && opts.removeRecords) && removeBtns.push("remove");
    removeBtns.forEach(btn => $(`button.fe-action-report-${btn}[data-token-id='${token.id}'`).replaceWith(''));

    const hasAdd = this.hasReportButton("insert", token.id);
    const hasRemove = this.hasReportButton("remove", token.id);
    const hasDownload = this.hasReportButton("download", token.id);

    opts.insertRecords && !hasAdd && this.addReportButton("Insert", token.id);
    opts.insertRecords && opts.removeRecords && !hasRemove && this.addReportButton("Remove", token.id);
    opts.downloadReport && !hasDownload && this.addReportButton("Download", token.id);
  }

  addCustomButton(action) {
    const actionLabel = this.fe.buttonActions[action]?.customLabel || 'Label';
    const btnHtml = `<button class="fe-action fe-action-${action}">${actionLabel}</button>`;
    this.editor.insertHtml(btnHtml);
    $('button.fe-action').each((_i, element) => {
      if ($(element).text().trim() === '') $(element).remove();
    });
    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
  }

  addReportButton(actionLabel, tokenId) {
    switch (actionLabel) {
      case 'Download':
        this.addReportDownloadButton(tokenId);
        break;
      case 'Insert':
        this.addReportInsertButton(tokenId);
        break;
      case 'Remove':
        this.addReportRemoveButton(tokenId);
        break;
    }
  }

  addReportDownloadButton(tokenId) {
    const token = this.getTokenById(tokenId);
    const label = `Download ${token?.fieldSchema?.label}`;
    const container = $(`div.fe-report[data-token-id="${tokenId}"]`)
      .parents(".cke_widget_reportwidget");
    container.after(`<button class="fe-action fe-action-report-download" data-token-id="${tokenId}">${label}</button>`);
    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
  }

  addReportInsertButton(tokenId) {
    const token = this.getTokenById(tokenId);
    const label = `Insert ${token?.fieldSchema?.label}`;
    const container = $(`div.fe-report[data-token-id="${tokenId}"]`).parents(".cke_widget_reportwidget");
    container.after(`<button class="fe-action fe-action-report-insert" data-token-id="${tokenId}">${label}</button>`);
    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
  }

  addReportRemoveButton(tokenId) {
    if (!this.hasReportButton("insert", tokenId)) {
      this.fs.error(`You need to add an "Add record" button first!`);
      return;
    }
    const label = `X`;
    const container = $(`div.fe-report[data-token-id="${tokenId}"] .fe-report-body`).last().children().last();
    container.append(`<button class="fe-action fe-action-report-remove" data-token-id="${tokenId}">${label}</button>`);
    this.contentChanged = true;
    this.dynamicContent = this.editor.getData();
  }

  cursorInsideReport(body) {
    const className = body ? 'fe-report-body' : 'fe-report';
    const elmContainer = this.editor.getSelection().getStartElement();
    return (elmContainer?.getParents()?.filter(p => p.$.className.includes(className)).length > 0);
  }

  deactivateReport(useCursor) {
    if (
      (useCursor && !this.cursorInsideReport()) ||
      (!useCursor && this.activeReportToken && !($(`div.fe-report[data-token-id='${this.activeReportToken.id}']`)).length)
    ) {
      this.activateTokenReport(null, true);
    }
  }

  setReportContent(token) {
    const $repElement = $(`div.fe-report.cke_widget_element[data-token-id='${token.id}']`);
    if ($repElement.length == 0) return;
    let content = this.emptyReportContent;
    const fields = this.reportOptions.fields
      .map(fId => token.control.reportTableSchema.fields
        .find(f => f.id == fId));
    if (fields.length)
      switch (this.reportOptions.type) {
        case 'table':
          content = this.getTableReport(token, fields);
          break;
        case 'vertical':
          content = this.getVerticalReport(token, fields);
          break;
      }
    $repElement.html(content);
    this.dynamicContent = this.editor.getData();
    this.refreshEditor();
  }

  getTableReport(token, fields) {
    const tableTitles = fields.map(f => `<td><strong>${f.label}</strong></td>`).join('');
    const tableFields = fields.map(f => `<td>${this.getTokenHtml(token, f)}</td>`).join('');
    return `
    <table width="100%" border="1">
      <thead><tr>${tableTitles}</tr></thead>
      <tbody><tr class="fe-report-body">${tableFields}</tr></tbody>
    </table>`;
  }

  getVerticalReport(token, fields) {
    const fieldLines = fields.map(f => `<p><strong>${f.label}</strong>: ${this.getTokenHtml(token, f)}</p>`).join('');
    return `
    <div class="fe-report-body">
      ${fieldLines}
    </div>`;
  }

  getTokenReportSettings(token) {
    const $element = $(`div.fe-report[data-token-id='${token.id}']`);
    this.prevReportOptions = { type: '', fields: [] };
    if ($element.length) {
      const $tag = $element.find('.fe-report-body');
      if ($tag.length) {
        this.prevReportOptions.type = ($tag.prop("tagName").toLowerCase() == 'div') ? 'vertical' : 'table';
      }
    }

    this.reportOptions = { type: this.prevReportOptions.type || '', fields: [] };

    token.options = token.options || {};
    token.options.downloadReport = this.hasReportButton("download", token.id);
    token.options.insertRecords = this.hasReportButton("insert", token.id);
    token.options.removeRecords = token.options.insertRecords && this.hasReportButton("remove", token.id);
  }

  hasReportButton(btnName, tokenId) {
    return ($(`button.fe-action-report-${btnName}[data-token-id="${tokenId}"]`).length > 0);
  }

  tokenIsReport(token) {
    return token?.fieldSchema?.fieldType && this.PROVIDER.reportFields.includes(token.fieldSchema.fieldType);
  }
  //#endregion Reports

  //#region Utils
  saveEditorScrollPosition() {
    this.editorScroll = $('.cke_contents').scrollTop();
  }

  restoreEditorScrollPosition() {
    this.editorScroll && $('.cke_contents').scrollTop(this.editorScroll);
    this.editorScroll = null;
  }

  copyUrlToClip(action) {
    this.uc.copyToClipboard(action, this.td.template);
  }

  designerIsFocused() {
    return (document.activeElement.tagName.toLowerCase() === 'body');
  }

  isAppAssigned() {
    return !!(this.td?.template || {}).appId;
  }

  validateTemplateSettings(checkConn) {
    this.tv.validateGroup(this.tv.validationGroups.TEMPLATE_SETTINGS, { template: this.td.template, ss: this.ss, checkConn });
  }

  validateMissingRequired() {
    this.tv.validateGroup(this.tv.validationGroups.REQUIRED_FIELDS, { template: this.td.template, schemas: this.ss.schemas });
  }

  validateTableFields() {
    this.tv.validateGroup(this.tv.validationGroups.TABLE_FIELDS, { template: this.td.template });
  }

  validateChoiceFields() {
    this.tv.validateGroup(this.tv.validationGroups.FIELD_CHOICES, { template: this.td.template });
  }

  validateSelectOptions() {
    this.tv.validateGroup(this.tv.validationGroups.SELECT_OPTIONS, { template: this.td.template });
  }

  validateEmptyReferences() {
    this.tv.validateGroup(this.tv.validationGroups.EMPTY_REFERENCES, { template: this.td.template });
  }

  refreshEditor() {
    this.editor.setData(this.dynamicContent);
    this.restoreEditorScrollPosition();
  }

  changeTemplateProp(prop, templateData) {
    this.ts.notifyUpdate([prop], templateData);
  }

  setDragDropSelector(rect, className, tagName) {
    this.$dragDropSelector.className = 'drag-drop-selector';
    if (className) this.$dragDropSelector.classList.add(className);
    if (rect) {
      this.$dragDropSelector.style.left = `${rect.left}px`;
      this.$dragDropSelector.style.top = `${rect.top}px`;
      this.$dragDropSelector.style.width = `${rect.width}px`;
      this.$dragDropSelector.style.height = `${rect.height}px`;
      this.$dragDropSelector.style.display = 'block';
      
      // Show target tag name as a label
      if (tagName) {
        if (!this.$dragDropSelector.querySelector('.target-tag-label')) {
          const label = document.createElement('div');
          label.className = 'target-tag-label';
          this.$dragDropSelector.appendChild(label);
        }
        const label = this.$dragDropSelector.querySelector('.target-tag-label');
        label.textContent = `<${tagName}>`;
      } else {
        const label = this.$dragDropSelector.querySelector('.target-tag-label');
        if (label) label.textContent = '';
      }
    } else {
      this.$dragDropSelector.style.display = 'none';
    }
  }
  
  setDragSourceSelector(rect) {
    if (!this.$dragSourceSelector) return;
    this.$dragSourceSelector.className = 'drag-source-selector';
    if (rect) {
      this.$dragSourceSelector.style.left = `${rect.left}px`;
      this.$dragSourceSelector.style.top = `${rect.top}px`;
      this.$dragSourceSelector.style.width = `${rect.width}px`;
      this.$dragSourceSelector.style.height = `${rect.height}px`;
      this.$dragSourceSelector.style.display = 'block';
    } else {
      this.$dragSourceSelector.style.display = 'none';
    }
  }
  //#endregion Utils

  //#region Modals
  closeModal() {
    this.modal?.close();
    this.modal = null;

    this.tokenIsReport(this.activeToken) && $(".report-loader").html(this.emptyReportContent);
  }

  async promptLogin() {
    const { realm } = this.td?.template || { realm: '' };
    this.fs.error(`You must login to ${realm}.${this.PROVIDER.domain} before proceeding.`);
    await this.openLoginModal(realm);

    this.reloadWindow();
  }

  reloadWindow() {
    this.fs.success("Reloading now...");
    this.$timeout(() => {
      this.$window.location.reload();
    }, 1500);
  }

  setConfirmLeave() {
    const unsavedMsg = actionText => `Unsaved Changes will be lost.\nAre you sure you want to ${actionText}?`;

    this.$window.onbeforeunload = () => {
      if (this.hasUnsavedChanges() && !this.ignoreLeaveConfirm) return unsavedMsg('leave this page');
    };

    this.$state.$current.onExit = () => {
      let isLeaving = true;

      if (this.hasUnsavedChanges() && !this.ignoreLeaveConfirm) {
        const actionText = this.discardOption ? 'discard changes' : 'leave this page';
        isLeaving = confirm(unsavedMsg(actionText));
        this.discardOption = false;
      }
      if (isLeaving) this.$window.onbeforeunload = undefined;
      return isLeaving;
    };
  }

  async updateConnection() {
    const uibModal = { scope: this.$scope, size: "md", backdrop: false };
    this.connTemplate = { id: this.ts.templateId, provider: await this.as.provider(), realm: await this.as.realm(), connectionId: this.ts.template.connectionId };
    uibModal.template =
      `<conn-update
          title="'Update Invalid Template Connection'"
          ignore-stored-conn="true"
          ignore-leave-confirm="$ctrl.ignoreLeaveConfirm"
          template="$ctrl.connTemplate">
        </conn-update>`;

    this.modal = this.$uibModal.open(uibModal);
    this.modal.result.then(
      closed => this.closeModal(),
      canceled => this.closeModal()
    );
  }
  //#endregion Modals

  //#region Save
  async saveChanges() {

    if (!this.validateTemplateContent()) return;

    this.loading = 'Saving...';

    // Purge references/tokens
    this.updateTemplateObjectsFromContent(null, true);
    this.cleanupTemplateContent();
    this.td.template.content = this.dynamicContent;

    this.td = await this.ts.saveTemplateData(this.td);
    this.PROVIDER.migrateTemplateToProvider && this.migrateProviderTemplate();

    this.loading = '';
    this.contentChanged = false;
    this.errorLevel = 0;

    this.$timeout(() => {
      this.ts.notifyUpdate(null, this.td, true);
      this.dynamicContent = this.td.template.content || '';
      this.refreshEditor();
      this.setReferenceTokensStyle();
      this.validateMissingRequired();
      this.validateTableFields();
      this.validateChoiceFields();
      this.validateSelectOptions();
      this.validateEmptyReferences();
      this.validateTemplateSettings(false);
    });

    this.fs.success("Template saved");
  }

  discardChanges() {
    this.discardOption = true;

    this.$state.go(
      'app.dynamic-builder',
      { 'templateId': this.td.template.id },
      { reload: true } //refreshes page
    );
  }

  async saveChangesAs(versionToRestore=null) {
    this.loading = "Copying Template...";
    this.duplicatingTemplate = true; //prevents onExit Dialogue box
    let title = `${this.td.template.title} - Copy`;
    const origTemplate = this.ts.originalTemplateData.template;
    if (origTemplate.title !== this.td.template.title) {
      title = this.td.template.title;
    }
    this.td.template.title = title;

    // Purge references/tokens
    this.updateTemplateObjectsFromContent(null, true);
    this.cleanupTemplateContent();
    this.td.template.content = this.dynamicContent;

    this.ignoreLeaveConfirm = true;

    const partialTemplate = angular.copy(this.td.template);
    try {
      const { "data": { "template": { id } } } = await this.tb.copyTemplate({ partialTemplate, versionToRestore });
      this.$state.go(
        'app.dynamic-builder',
        { 'templateId': id },
        { reload: true } //refreshes page
      );
    } catch (error) {
      this.duplicatingTemplate = false; //prevents onExit Dialogue box
      this.fs.error(error);
    }
  }

  hasUnsavedChanges() {
    return this.contentChanged || this.ts.templateHasChanges(this.td?.template);
  }

  isSourceMode() {
    return CKEDITOR?.instances?.dynamicEditor?.mode === 'source';
  }
  //#endregion Save

}

export default {
  bindings: {},
  templateUrl: "dynamic-builder/dynamic-builder/dynamic-builder.component.html",
  controller: DynamicBuilderCtrl
};
